// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__38Vtc","bigColWidth":"Table_bigColWidth__168HA","biggerColWidth":"Table_biggerColWidth__EXycU","row":"Table_row__3qQFO","col":"Table_col__3eH_M"};